/* ============================================================
   DATA INSTALASI GAWAT DARURAT (IGD)

   Letakkan di: app/layanan/igd/igd.js

   ============================================================
   ⚠️ PINDAHKAN FOLDERNYA

   Gambar tadinya kamu taruh di app/fasilitas/igd/images/. Berkas ini
   mengharapkannya di app/layanan/igd/images/.

   Pindahkan seluruh folder `igd` dari `fasilitas` ke `layanan`,
   lalu hapus folder `fasilitas` kalau jadi kosong.

   KENAPA layanan, bukan fasilitas: menu Header sudah menunjuk ke
   /layanan/igd bersama tiga belas layanan lain, dan IGD adalah
   sesuatu yang pasien datangi dan gunakan - bukan sekadar ruangan
   seperti CT-Scan. Yang paling penting: cukup SATU alamat. Dua
   alamat untuk satu hal memecah peringkat pencarian dan membingungkan
   pengunjung.

   ============================================================
   HALAMAN INI TIDAK PUNYA FORMULIR RESERVASI - DISENGAJA

   Halaman lama di rsjmc.id menulis "Silakan hubungi nomor dibawah ini
   untuk melakukan reservasi" - kalimat yang tersalin dari halaman
   layanan lain. IGD tidak dipesan. Orang yang membuka halaman ini
   sedang panik, atau sedang menemani orang yang kesakitan.

   Yang dia butuhkan ada tiga, dan hanya tiga:
     1. nomor yang bisa langsung ditelepon
     2. alamat yang bisa langsung dibuka di peta
     3. kepastian bahwa IGD buka sekarang

   Formulir isian, pilihan jadwal, dan tombol WhatsApp justru
   menghalangi ketiganya. Mengetik pesan saat gawat darurat adalah
   hal terakhir yang boleh diminta halaman ini.
   ============================================================ */

import foto1 from "./images/2.png";

/* Alamat lengkap dibaca dari poster MCU Ekonomis (12.jpeg), yang
   mencantumkannya paling rinci. Perhatikan: beberapa poster lain
   menulis kode pos 17240 - itu keliru, yang benar 12740. */
export const IGD = {
  buka24Jam: true,

  /* Urutan di sini menentukan urutan kartunya di halaman, dan yang
     bertanda `utama` jadi tombol besar di kepala halaman. Nomor
     langsung IGD ditaruh paling depan; nomor hunting menyusul, karena
     hunting biasanya masuk ke operator dulu - satu lapis lebih jauh
     dari petugas yang bisa langsung menolong. */
  telepon: [
    {
      label: { id: "IGD 24 Jam", en: "24-hour Emergency" },
      tampil: "+62 878-9355-7908",
      tel: "+6287893557908",
      /* Nomor ini punya `wa`, jadi angkanya di kartu membuka WhatsApp.
         TOMBOL BESAR di kepala halaman tetap memanggil lewat telepon,
         bukan WhatsApp - lihat komentar di IgdContent.jsx. */
      wa: "6287893557908",
      pesanWa: {
        id: "Halo IGD RS Jakarta Medical Center,\n\nSaya ingin menanyakan mengenai penanganan gawat darurat.\n\nMohon bantuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center emergency department,\n\nI would like to ask about emergency care.\n\nThank you for your help.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      /* Nomor yang punya medan `wa` diarahkan ke WhatsApp, bukan ke
         aplikasi telepon. Nomor IGD di atas sengaja TIDAK punya medan
         ini: keadaan gawat darurat ditangani lewat panggilan suara,
         bukan pesan yang menunggu dibaca. */
      wa: "62811901874",
      /* Tanpa `pesanWa` sendiri, nomor ini memakai PESAN_WA umum di
         bawah. */
      utama: false,
    },
  ],

  alamat: {
    baris: "Jl. Warung Buncit Raya No. 15, RT 10/RW 05, Kalibata, Kec. Pancoran, Jakarta Selatan 12740",
    /* Dipakai untuk membuka Google Maps. Sengaja memakai pencarian
       berdasarkan nama dan alamat, bukan koordinat - kalau nanti
       titiknya digeser di Google Maps, tautannya tetap benar. */
    cari: "Rumah Sakit Jakarta Medical Center, Jl. Warung Buncit Raya No. 15, Jakarta Selatan",
  },
};

/* ============================================================
   PESAN PEMBUKA WHATSAPP

   Terisi otomatis di kolom ketik WhatsApp saat nomor customer service
   ditekan. WhatsApp hanya MENGISI, tidak mengirim - pasien masih bisa
   menyunting atau menghapusnya sebelum menekan kirim.

   Ditulis sopan tapi pendek, dan menyebutkan bahwa nomornya didapat
   dari halaman IGD - dengan begitu customer service langsung tahu
   konteksnya tanpa harus bertanya dulu.

   TIDAK diberi salam "selamat pagi/siang" karena halaman tidak tahu
   jam berapa pesannya dikirim, dan salam yang meleset justru terbaca
   janggal.
   ============================================================ */
export const PESAN_WA = {
  id: "Halo RS Jakarta Medical Center,\n\nSaya ingin menanyakan informasi mengenai layanan Instalasi Gawat Darurat.\n\nMohon bantuannya. Terima kasih.",
  en: "Hello RS Jakarta Medical Center,\n\nI would like to ask about the emergency department services.\n\nThank you for your help.",
};

export const FOTO = [
  {
    gambar: foto1,
    judul: {
      id: "Instalasi Gawat Darurat RS JMC",
      en: "RS JMC Emergency Department",
    },
    alt: {
      id: "Gedung Instalasi Gawat Darurat Rumah Sakit Jakarta Medical Center.",
      en: "The emergency department building at Jakarta Medical Center Hospital.",
    },
  },

  /* ⚠️ GALERI FOTO TIDAK PERNAH MUNCUL SELAMA ARRAY INI CUMA SATU.

     IgdContent memakai FOTO[0] untuk kepala halaman, lalu
     FOTO.slice(1) untuk galeri di bawah. Dengan satu foto, slice(1)
     kosong dan SELURUH bagian galeri tidak dirender - salah satu
     sebab halaman ini terasa kosong.

     Tambahkan foto kedua dan seterusnya di sini dengan bentuk yang
     sama. Yang paling berguna untuk pengunjung, berurutan:
       - pintu masuk IGD dari arah jalan (supaya sopir tahu belok
         di mana pada malam hari)
       - area drop-off / tempat ambulans berhenti
       - meja pendaftaran IGD
       - ruang tunggu keluarga

     Foto ruang tindakan dan pasien JANGAN dipasang tanpa izin
     tertulis. Wajah pasien di foto rumah sakit adalah data pribadi
     kesehatan; memasangnya tanpa persetujuan adalah masalah hukum,
     bukan sekadar masalah etika. */
];

/* ============================================================
   NOMOR DARURAT DI LUAR RUMAH SAKIT

   Kedua nomor di bawah adalah layanan pemerintah, gratis, berlaku
   nasional, dan diverifikasi dari sumber resmi:

     112 - nomor darurat tunggal, diselenggarakan Komdigi bersama
           pemerintah daerah. Mencakup semua jenis kejadian darurat
           (polisi, pemadam, medis, bencana) dan masih bisa dipanggil
           saat ponsel terkunci atau tanpa pulsa.
           Sumber: layanan112.komdigi.go.id/tentang

     119 - khusus kegawatdaruratan MEDIS, dikelola Kementerian
           Kesehatan lewat sistem SPGDT. Panggilan diteruskan ke
           Public Safety Center terdekat yang akan mengirim ambulans.
           Dasar hukum: Permenkes No. 19 Tahun 2016.
           Sumber: kemkes.go.id

   ⚠️ PERIKSA TAMPILANNYA SETELAH DIPASANG.

   IgdContent menggabungkan array ini ke dalam grid yang SAMA dengan
   nomor telepon RS:

       [...IGD.telepon.filter((n) => !n.utama), ...DARURAT_LUAR]

   Jadi 112 dan 119 akan tampil sebagai kartu yang bentuknya persis
   sama dengan kartu "Hunting" dan "Customer Service". Pembeda satu-
   satunya adalah tulisan label kecil di atas angkanya.

   Risikonya: pengunjung yang membaca sekilas bisa mengira 112 adalah
   nomor RS JMC. Label di bawah sudah saya tulis setegas mungkin
   ("Darurat Nasional", bukan sekadar "112") untuk mengurangi itu.

   Kalau setelah dilihat masih rancu, ada TEKS.daruratLuar di
   IgdContent yang sudah ditulis tapi belum pernah dipakai - itu
   memang disiapkan untuk memberi bagian terpisah bagi nomor-nomor
   ini. Bilang saja kalau kamu mau saya pisahkan.
   ============================================================ */
export const DARURAT_LUAR = [
  {
    label: { id: "Darurat Nasional", en: "National Emergency" },
    tampil: "112",
    tel: "112",
  },
  {
    label: { id: "Ambulans / Darurat Medis", en: "Ambulance / Medical Emergency" },
    tampil: "119",
    tel: "119",
  },
];

/* ============================================================
   YANG PERLU DISIAPKAN

   Muncul di halaman sebagai daftar butir di bawah judul
   "Yang Perlu Disiapkan".

   ============================================================
   BUTIR PERTAMA SENGAJA BUKAN BARANG BAWAAN.

   Daftar "yang perlu dibawa" punya efek samping yang berbahaya di
   halaman IGD: ia membuat orang berhenti mencari dompet, kartu, atau
   berkas sebelum berangkat. Padahal justru itu yang tidak boleh
   terjadi.

   Karena itu butir pertama meniadakan syarat, bukan menambah syarat.
   Isinya bukan pendapat: UU No. 1  7 Tahun 2023 tentang Kesehatan
   Pasal 174 ayat (2) melarang fasilitas kesehatan menolak pasien
   gawat darurat, meminta uang muka, atau mendahulukan urusan
   administratif sampai pelayanan tertunda.

   Semua butir setelahnya diberi kata "bila ada" - itu bukan gaya
   bahasa, itu yang membedakan daftar bantuan dari daftar syarat.

   ============================================================
   ⚠️ YANG BELUM ADA DI SINI, DAN KENAPA

   Daftar ini TIDAK menyebut apa pun yang khusus RS JMC: prosedur
   pendaftaran IGD, apakah BPJS diterima di IGD, alur rujukan, atau
   perkiraan biaya. Semua itu adalah kebijakan rumah sakit yang tidak
   bisa ditebak dari luar, dan menebaknya di halaman gawat darurat
   adalah kesalahan yang paling mahal di seluruh situs ini.

   Tanyakan ke bagian pendaftaran dan bagian jaminan, lalu tambahkan
   sendiri di bawah. Yang paling sering dicari pengunjung, berurutan:

     1. Apakah IGD melayani pasien BPJS? Dengan syarat apa?
        (Ini pertanyaan nomor satu, dan jawabannya tidak sama di
        setiap RS swasta. Jangan ditulis sebelum dipastikan.)
     2. Apakah ada layanan ambulans jemput? Nomor mana yang dihubungi?
     3. Di mana pintu masuk IGD dan di mana parkir/drop-off-nya?
        (Ini yang paling menolong pada jam 2 pagi, dan paling sering
        dilupakan rumah sakit karena terasa terlalu sepele.)
   ============================================================ */
export const CATATAN = [
  {
    id: "Jangan menunda keberangkatan karena berkas belum lengkap. Dalam keadaan gawat darurat, penanganan pasien didahulukan dan urusan administrasi diselesaikan kemudian.",
    en: "Do not delay coming because your documents are incomplete. In an emergency, treatment comes first and the paperwork is handled afterwards.",
  },
  {
    id: "Kartu identitas pasien (KTP, SIM, atau paspor), bila ada.",
    en: "The patient's ID card (KTP, driving licence, or passport), if available.",
  },
  {
    id: "Kartu BPJS Kesehatan atau kartu asuransi, bila ada.",
    en: "BPJS Kesehatan card or insurance card, if available.",
  },
  {
    id: "Obat yang sedang rutin diminum. Membawa kemasannya atau memotretnya sudah cukup - nama dan dosis obat sangat membantu tim medis.",
    en: "Any medication the patient takes regularly. Bringing the packaging or a photo of it is enough - the name and dose help the medical team a great deal.",
  },
  {
    id: "Informasi riwayat alergi obat, penyakit yang sedang dijalani, serta operasi atau tindakan medis sebelumnya.",
    en: "Details of any drug allergies, ongoing medical conditions, and previous surgery or procedures.",
  },
  {
    id: "Surat rujukan dan hasil pemeriksaan terakhir, bila pasien datang atas rujukan dokter atau fasilitas kesehatan lain.",
    en: "A referral letter and recent test results, if the patient is referred by another doctor or health facility.",
  },
  {
    id: "Nomor telepon keluarga terdekat yang dapat dihubungi.",
    en: "A contact number for the patient's closest family member.",
  },
];
